// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, object, oneOfType, string } from 'prop-types'
import ErrorSimple from './ErrorSimple'

const LabeledInput = props => {
  const {
    autoFocus,
    className,
    clearable,
    disabled,
    id,
    input,
    inputClasses = '',
    label,
    meta: { asyncValidating, error },
    placeholder,
    onBlurCustom,
    onChangeCustom,
    onFocusCustom,
    onPasteCustom,
    readOnly,
    type,
  } = props

  const onBlurC = e => onBlurCustom(e, input.onBlur)
  const onChangeC = e => onChangeCustom(e, input.onChange)
  const onFocusC = e => onFocusCustom(e, input.onFocus)

  const clearValue = () => {
    if (typeof clearable === 'function') {
      clearable()
    } else {
      input.onChange('')
    }
  }

  // if the input is clearable, it isn't disabled and it has a value,
  // then you can clear it
  const clearInput = (
    !disabled && clearable && input.value
      ? (
        <span
          className={'clear-input-button pointer'}
          onClick={clearValue}>
          {'X'}
        </span>
      ) : null
  )

  return (
    <div
      className={`labeled-input ${className || ''}`}
      title={input.value}>
      { label && <label id={`${id}-label`}>{label}</label> }
      <div className={asyncValidating ? 'async-validating' : ''}>
        <input
          {...input}
          autoFocus={autoFocus}
          className={inputClasses}
          disabled={disabled}
          id={id}
          onBlur={onBlurCustom ? onBlurC : input.onBlur}
          onChange={onChangeCustom ? onChangeC : input.onChange}
          onFocus={onFocusCustom ? onFocusC : input.onFocus}
          onPaste={onPasteCustom ? e => onPasteCustom(e, input.onChange) : null}
          placeholder={placeholder || label || ''}
          readOnly={readOnly}
          type={type || 'text'} />
        <i className={'fa fa-spinner fa-pulse fa-fw'} />
        <ErrorSimple
          error={error}
          idRoot={id} />
        {clearInput}
      </div>
    </div>
  )
}

LabeledInput.propTypes = {
  autoFocus: bool,
  className: string,
  clearable: oneOfType([
    bool,
    func,
  ]),
  disabled: bool,
  id: string.isRequired,
  inputClasses: string,
  input: object.isRequired,
  label: oneOfType([
    string,
    object,
  ]),
  meta: object.isRequired,
  onBlurCustom: func,
  onChangeCustom: func,
  onFocusCustom: func,
  onPasteCustom: func,
  placeholder: string,
  readOnly: bool,
  type: string,
}

export default LabeledInput
